import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import DatePicker from '@appbase/components/DatePicker/DatePicker.vue'
import api from '@hr/api';
import * as dateutil from '@appbase/util/date-helper'
import * as accountTypes from '@account/store/types'
import { mapGetters } from 'vuex';

@Component({  
    components:{DatePicker},
    computed: mapGetters({
        user: accountTypes.CURRENT
    }),
})
export default class LeaveAdminHeader extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: String }) searchFilter!: string;
    @Prop({ type: String }) searchWord!: string;
    @Prop({ type: Number }) pageNum!: number;
    @Prop({ type: Number }) rowSize!: number;
    @Prop({ type: String }) pStartDate!: string;
    @Prop({ type: String }) pEndDate!: string;

    @Prop({ type: Boolean }) isPersonView!: boolean

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    user!: account.TCurrent;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    todayDate: Date = new Date();
    // startDate: string =  dateutil.uGetDateFormat('yyyy-MM-DD', new Date(new Date(this.todayDate.setDate(1)).setMonth(1)));
    // endDate: string =  dateutil.uGetDateFormat('yyyy-MM-DD', new Date(this.todayDate));
    startDate: string = dateutil.uGetDateFormat('yyyy-MM-DD', new Date(this.todayDate));
    endDate: string = dateutil.uGetDateFormat('yyyy-MM-DD', new Date(this.todayDate));
    leaveCode: number = 0;
    value: string = '';
 
    codes: Array<any> = [];

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    async search() {
        if(this.startDate == '' || this.endDate == ''){
            await (window as any).alertAsync(this.$t('기간은_필수_입력입니다').toString());
            return false;
        }else if(dateutil.IEDate(this.startDate) > dateutil.IEDate(this.endDate)){
            await (window as any).alertAsync(this.$t('시작일이_종료일보다_이후일_수_없습니다').toString());
            return false;
        }else{
            var data = {
                searchFilter: this.searchFilter,
                searchWord: this.value,
                startDate: this.startDate,
                endDate: this.endDate,
                leaveCode: this.leaveCode,
                pageNum: 1,
                rowSize: 20,
            }
            this.$emit('load', data);
        }   
    }

    getExcelList(){
        var searchFilter = (this.value == '') ? null : this.searchFilter;
        api.leave.downloadListExcel(searchFilter, this.value, this.startDate, this.endDate, this.leaveCode);
    }

    created(){
        
        api.leave.getLeaveCodes(this.user.company.comCode).then(res=>{
            this.codes = res as any[];
            this.codes.push({
                id: 0,
                name: '휴가구분',
                nameEng: 'All',
                nameJpn: 'All',
                nameChi: 'All'
            })

            // 사용자 언어 구분법 확인 후 수정 예정
            // this.codes.map(c=>{
            //     if(this.user.userConfig.language.indexOf('EN')>0){
            //         c.name = c.nameEng
            //     }
            // })
        })
    }    

    mounted(){
        this.startDate =  dateutil.uGetDateFormat('yyyy-MM-DD', new Date(new Date().setMonth(0, 1)));
        this.endDate =  dateutil.uGetDateFormat('yyyy-MM-DD', new Date(new Date().setMonth(11, 31)));
        // this.endDate =  dateutil.uGetDateFormat('yyyy-MM-DD', new Date(new Date().setMonth(1, 1)));

    }
}